export default {
  methods: {
    openSnackbar(message, messageType) {
      var snackbar = {
        showSnackbar: true,
        color: this.backgroundColor(messageType),
        timeout: 5000,
        buttonText: "",
        message: message,
      }

      this.$store.commit("setSnackbar", snackbar);
    },
    openToastSnackbar(message, messageType, buttonText) {
      var snackbar = {
        showSnackbar: true,
        color: this.backgroundColor(messageType),
        timeout: 0,
        buttonText: buttonText,
        message: message,
      }

      this.$store.commit("setSnackbar", snackbar);
    },
    closeSnackbar(store) {
      var snackbar = store.getters.snackbar;
      snackbar.showSnackbar = false;
      store.commit("setSnackbar", snackbar);
    },
    backgroundColor(type) {
      switch ( type ) {
        case "error":
          return "red";
        case "warn":
          return "orange";
        case "success":
          return "green";
        default:
          return "grey";
      }
    }
  },
};
